import { z } from "zod";

export const dtMetaSchema = z.object({
    totalRowCount: z.number(),
});
